import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import ProposalList from './ProposalsList';
import CreateProposal from './CreateProposal';
import EmptyState from '../../components/EmptyState';
import ProposalPreview from './CreateProposal/ProposalPreview';
import { cleanProposalData, getProposalsByPage } from '../../store/actions/ProposalsAction';

import './EconomicProposal.scss';

const image = '/img/empty-state/cotizacion.svg';
const mobileImage = '/img/empty-state/cotizacion-mb.svg';

const EconomicProposal = ({ membership, uid, getProposalsByPage, proposals, proposalData, cleanProposalData, proposalSelected }) => {
  const mobileView = useMediaQuery('(max-width: 959px)');
  const [list, setList] = useState(false);
  const [principal, setPrincipal] = useState(true);
  const [createView, setCreateView] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [searchValues, setSearchValues]= useState([]);
  const [showPreview, setShowPreview] = useState(false);

  useEffect(() => {
    if(searchValues.length === 0) {
      const params = {
        uid: uid,
        page: 1,
        limit: 9,
      }
      getProposalsByPage(params)
    }

    if((proposalData && Object.values(proposalData).length > 0) || (proposalSelected && Object.values(proposalSelected).length > 0 )){
      cleanProposalData();
    }
  }, [])
  
  const handleClickCreate = () => {
    setCreateView(true)
    setList(false)
  }

  if (membership && membership.type === 'Freemium') {
    return <Redirect to="/dashboard" />;
  }

  return (
    <div className="EconomicProposal">
      {(!showPreview && !createView && proposals && proposals.data && proposals.data.length > 0) || (searchValues.length > 0 && proposals && proposals.data && proposals.data.length === 0) ?
        <ProposalList 
          handleClickCreate={handleClickCreate} 
          searchValues={searchValues} 
          setSearchValues={setSearchValues}
          setCreateView = { setCreateView }
          setShowPreview = {setShowPreview}
        /> 
        :
        !createView && !proposals ?
        <div className="EconomicProposal_emptyStateContainer">
          <EmptyState
            title={
              <span>
                Te invitamos a crear
                <br />
                propuestas económicas
              </span>
            }
            subtitle={
              <span>
                En este apartado podrás crear propuestas económicas de manera
                fácil y rápida. Puedes compartir estas propuestas con clientes
                que te hayan contactado mediante nuestra plataforma o clientes
                de tu despacho, ingresando únicamente su número telefónico o
                correo electrónico.
              </span>
            }
            img={mobileView ? mobileImage : image}
            imgAlign={'center'}
            //direction={ROUTES.ECONOMIC_PROPOSAL}
            handleClick={() => {
              handleClickCreate()
              // setList(true);
              // setPrincipal(false);
            }}
            callToAction="Crear propuesta económica"
            buttonStyles={{ width: 256, padding: 0 }}
          />
        </div>
        : null
      }
      {list && proposals && proposals.data && proposals.data.length > 0 && 
        <ProposalList 
          handleClickCreate={handleClickCreate} 
          setShowPreview={setShowPreview}
        />
      }

      {createView && <CreateProposal setCreateView={setCreateView} />}

      {showPreview && 
        <ProposalPreview 
          setShowPreview={setShowPreview} 
          pdfValue={proposalSelected && Object.values(proposalSelected).length > 0 && proposalSelected.pdfUrl} 
        />}

    </div>
  );
};

const mapStateToProps = state => ({
  uid: state.authClient.uid, 
  membership: state.authClient.membership,
  proposals: state.proposalsReducer.proposals,
  proposalData: state.proposalsReducer.newProposalData,
  proposalSelected: state.proposalsReducer.selectedProposal,
})

const mapDispatchToProps = dispatch => ({
  getProposalsByPage: params => dispatch(getProposalsByPage(params)),
  cleanProposalData: () => dispatch(cleanProposalData()),
})
export default connect(mapStateToProps, mapDispatchToProps)(EconomicProposal);
